<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-stepper v-model="e1" class="transparent elevation-0">
                    <v-card class="mb-5">
                         <v-stepper-header class="autoheight">
                            <v-stepper-step @click="setStep(1)" step="1">{{ languageData.stepperInfo }}</v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step @click="setStep(2)" step="2">{{ languageData.stepperVOB }}</v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step  @click="setStep(3)" step="3">{{ languageData.stepperEinKlick }}</v-stepper-step>
                        </v-stepper-header>
                    </v-card>
                    <v-card :class="$vuetify.breakpoint.smAndUp ? 'px-10' : null" >
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-card>
                                    <v-row justify="center">
                                        <v-col v-if="guideKey === 'all'" cols="12">
                                            <p class="guide-paragraph" v-for="(item, index) in getArrayWithUniqueValues(languageData.guidesInfo)" :key="index">
                                                {{ item }}
                                            </p>
                                        </v-col>
                                        <v-col v-else-if="typeof guideKey === 'object' || typeof guideKey === 'array' " cols="12">
                                            <p class="guide-paragraph" v-for="(item, index) in guideKey" :key="index">
                                                {{ languageData.guidesInfo[item] }}
                                            </p>
                                        </v-col>
                                         <v-col v-else cols="12">
                                            <p class="guide-paragraph">
                                                {{ languageData.guidesInfo[guideKey] }}
                                            </p> 
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <v-card>
                                    <v-row justify="center">
                                        <v-col v-if="guideKey === 'all'" cols="12">
                                             <p class="guide-paragraph" v-for="(item, index) in getArrayWithUniqueValues(languageData.guidesVOB)" :key="index">
                                                {{ item }}
                                            </p>
                                        </v-col>
                                        <v-col v-else-if="typeof guideKey === 'object' || typeof guideKey === 'array' " cols="12">
                                            <p class="guide-paragraph" v-for="(item, index) in guideKey" :key="index">
                                                {{ languageData.guidesVOB[item] }}
                                            </p>
                                        </v-col>
                                        <v-col v-else cols="12">
                                            <p class="guide-paragraph">
                                                {{ languageData.guidesVOB[guideKey] }}
                                            </p>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-stepper-content>
                            <v-stepper-content step="3">
                                <v-card>
                                    <v-row justify="center">
                                        <v-col v-if="guideKey === 'all'" cols="12">
                                             <p class="guide-paragraph" v-for="(item, index) in getArrayWithUniqueValues(languageData.guidesEinKlick)" :key="index">
                                                {{ item }}
                                            </p>
                                        </v-col>
                                        <v-col v-else-if="typeof guideKey === 'object' || typeof guideKey === 'array' " cols="12">
                                            <p class="guide-paragraph" v-for="(item, index) in guideKey" :key="index">
                                                {{ languageData.guidesEinKlick[item] }}
                                            </p>
                                        </v-col>
                                        <v-col v-else cols="12">
                                            <p class="guide-paragraph">
                                                {{ languageData.guidesEinKlick[guideKey] }}
                                            </p>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-stepper-content>
                        </v-stepper-items>
                      <v-col cols="12">
                        <p class="guide-paragraph" style="font-weight: 500">{{ languageData.guideFooter }}</p>
                      </v-col>
                    </v-card>
                </v-stepper>
            </v-col>
        </v-row>
    </v-container>
</template>

<script type="text/javascript">

export default {
  name: "Guides",
  props: {
    guideKey: [String, Object, Array],
  },
  data() {
      return {
        e1: 1,
      }
  },
  methods: {
    setStep: function(step) {
        this.e1 = step;
    },
    getArrayWithUniqueValues(guide) {
        const guideValuesArray = Object.values(guide);
        return Array.from(new Set(guideValuesArray));
    }
  },
}
</script>
